import { useContext } from "react"
import { Field } from "formik"
import { FormContext } from "../../context/formContext"
import { InputNumber } from "primereact/inputnumber"
import DescriptionTooltip from "./helpers/DescriptionTooltip";
import styles from "../../styles/Form.module.css"

export default function TypeNumber({ field, block, index }) {
  const isRequired = JSON.parse(field.field_validation.required[0])
  const form = useContext(FormContext)
  const isDisabled = form ? form.blocksSaved[block] : false
  return (
    <div className={styles.field} style={{ order: index }}>
      <label className={styles.label} style={{ gap: "10px" }}>
        <span>
          {field.field_label}
          {isRequired && <span className={styles.asterisk}> *</span>}
        </span>
        {field.field_description &&
          <DescriptionTooltip
            fieldName={field.field_name}
            fieldDescription={field.field_description}
          />
        }
      </label>
      <Field name={field.field_name}>
        {({ field: formikField, meta }) => {
          return (
            <>
              <InputNumber
                inputId="integeronly"
                name={formikField.name}
                value={formikField.value}
                onValueChange={formikField.onChange}
                disabled={isDisabled}
                onBlur={formikField.onBlur}
                showButtons
              />
              {meta.touched && meta.error && (
                <div className={styles.errFieldMsg}>{meta.error}</div>
              )}
            </>
          )
        }}
      </Field>
    </div>
  )
}
